import * as React from "react";
const SvgFiBrandsSiemens = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M.074 13.763v-.722q.616.194 1.091.194.655 0 .655-.346a.29.29 0 0 0-.095-.217q-.098-.093-.5-.258-.722-.297-.941-.506A.93.93 0 0 1 0 11.211q0-.542.413-.826.408-.282 1.064-.281.362 0 1.046.133v.694a2.6 2.6 0 0 0-.946-.203q-.615 0-.615.338 0 .126.124.206.103.064.568.274.669.297.891.517a.9.9 0 0 1 .263.674q0 .594-.517.906-.419.253-1.085.253-.56 0-1.132-.133M3.386 10.167h1.02v3.655h-1.02zM5.343 13.822v-3.655h2.618v.661H6.327v.826H7.75v.603H6.327v.867h1.676v.698zM8.67 13.822v-3.655h1.324l.919 2.336.943-2.336h1.257v3.655h-.968v-2.588l-1.072 2.626h-.632l-1.052-2.626v2.588zM14.05 13.822v-3.655h2.618v.661h-1.634v.826h1.423v.603h-1.423v.867h1.677v.698zM17.383 13.822v-3.655h1.183l1.255 2.447v-2.447h.72v3.655h-1.15l-1.289-2.479v2.479zM21.265 13.763v-.722q.61.194 1.09.194.657 0 .656-.346a.3.3 0 0 0-.092-.217q-.098-.093-.503-.258-.72-.294-.941-.506a.93.93 0 0 1-.283-.7q0-.54.413-.824.408-.282 1.064-.281.37 0 .955.118l.09.016v.694a2.6 2.6 0 0 0-.948-.203q-.612 0-.612.338-.001.126.124.206.099.062.57.274.666.297.889.517a.9.9 0 0 1 .263.674 1 1 0 0 1-.514.906q-.421.253-1.087.253-.563 0-1.134-.133"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsSiemens;
